import { toTimestamp } from '../date-converter';

export default function passesDateRangeFilter(item, filter) {
    // IF the active filter does not have value then we pass the check without question
    // For Date range filters, the first value is From and the 2nd value is To
    if (!filter.values.length || (!filter.values[0] && !filter.values[1])) { return true; }

    // From check
    if (filter.values[0]) {
        const fromDate = toTimestamp(filter.values[0]);
        if (item.timestamp < fromDate) {
            return false;
        }
    }

    // To check
    if (filter.values[1]) {
        const toDate = toTimestamp(filter.values[1]);
        if (item.timestamp > toDate) {
            return false;
        }
    }

    // All passed
    return true;
}
